export enum SlideTypes {
  ID_DOCUMENT = 'id-document',
  US_ADDRESS = 'us-address'
}
export interface Slide {
  title: string;
  descriptionStart: string;
  img: string;
  value?: string;
  descriptionEnd?: string;
  step?: string[];
  subTitleStart?: string;
  subTitleValue?: string;
  subTitleEnd?: string;
  link?: string;
  type?: SlideTypes;
}
